<template>
  <div id="app">
    <router-view />
    <!-- <common-modal 
      :title="'시스템 점검중'"
      :message="'안녕하세요, 솔닥입니다.<br><br>더 안정적인 서비스 제공을 위해 아래 시간 동안 시스템 점검이 진행될 예정입니다.<br><br>점검 일시: 2026.01.21 수요일 오후 21:00 ~ 22:00<br><br>점검 시간 동안은 서비스 접속 및 이용이 어려울 수 있으며, 점검 완료 후 정상적으로 이용하실 수 있습니다.'"
      :buttonCount="0"
  />  -->
  </div>
</template>

<script>
  import CommonModal from '@/components/modals/CommonModal';
export default {
  name: 'App',
  components: {CommonModal},
}
</script>

<style>
#app{
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Pretendard';
    box-sizing: border-box;
}

html { 
  overscroll-behavior: none;        /* iOS16+ 바운스/풀다운 억제 */
}

.v-application {
  font-family: 'Pretendard', sans-serif !important;
}

@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Thin.ttf') format('truetype');
  font-weight: 100;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraLight.ttf') format('truetype');
  font-weight: 200;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Light.ttf') format('truetype');
  font-weight: 300;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Regular.ttf') format('truetype');
  font-weight: 400;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Medium.ttf') format('truetype');
  font-weight: 500;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-SemiBold.ttf') format('truetype');
  font-weight: 600;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Bold.ttf') format('truetype');
  font-weight: 700;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-ExtraBold.ttf') format('truetype');
  font-weight: 800;
}
@font-face {
  font-family:'Pretendard';
  src: url('assets/fonts/Pretendard-Black.ttf') format('truetype');
  font-weight: 900;
}
</style>



// WEBPACK FOOTER //
// src/App.vue